import { FaUserTie, FaArrowRight } from "react-icons/fa";
import "./SessionRecruitment.css";

const recruitmentsData = [
  {
    id: "giang-vien",
    icon: "/images/home/recruit/icons/icon1.webp",
    title: "Giảng viên",
    subTitle: "Tuyển dụng giảng viên",
    image: "/images/home/recruit/recruit1.webp",
    description:
      "Tham gia đào tạo nguồn nhân lực chuyên nghiệp cho các ngành Bếp Nóng, Bếp Bánh, Pha chế và Nhà Hàng – Khách Sạn cho nước nhà cùng Design24. Đăng ký ngay!",
  },
  {
    id: "quan-ly",
    icon: "/images/home/recruit/icons/icon2.webp",
    title: "Quản lý",
    subTitle: "Tuyển dụng quản lý",
    image: "/images/home/recruit/recruit2.webp",
    description:
      "Bạn có muốn thể hiện kỹ năng quản lý của mình? Bạn muốn làm việc trong môi trường chuyên nghiệp, phát triển cùng Design24. Hãy ứng tuyển ngay tại đây!",
  },
  {
    id: "chuyen-vien",
    icon: "/images/home/recruit/icons/icon3.webp",
    title: "Chuyên viên",
    subTitle: "Tuyển dụng chuyên viên",
    image: "/images/home/recruit/recruit3.webp",
    description:
      "Design24 là môi trường cho bạn phát triển cơ hội làm việc năng động và chuyên nghiệp với các vị trí quan trọng khác nhau. Tìm vị trí thích hợp tại đây!",
  },
  {
    id: "nhan-vien",
    icon: "/images/home/recruit/icons/icon4.webp",
    title: "Nhân viên",
    subTitle: "Tuyển dụng nhân viên",
    image: "/images/home/recruit/recruit4.webp",
    description:
      "Bạn muốn học hỏi kinh nghiệm và phát triển tiềm năng của bản thân trong một môi trường làm việc tốt? Hãy gia nhập Gia đình Design24 tại vị trí phù hợp!",
  },
];

const SessionRecruitment = () => (
  <section className="recruitment">
    <div className="recruitment__container">
      {/* Icon + Title */}
      <div className="recruitment__header">
        <div className="recruitment__icon">
          <FaUserTie />
        </div>
        <h2 className="recruitment__title">Tuyển dụng</h2>
      </div>

      {/* Cards */}
      <div className="recruitment__cards">
        {recruitmentsData.map(
          ({ id, icon, title, subTitle, image, description }) => (
            <div
              key={id}
              className="recruitment__card"
            >
              <div className="recruitment__card-icon-wrapper">
                <img
                  src={icon}
                  alt={`${title} icon`}
                  className="recruitment__card-icon"
                />
              </div>

              <h3 className="recruitment__card-title">{title}</h3>

              <img
                src={image}
                alt={title}
                className="recruitment__card-image"
              />

              <h4 className="recruitment__card-subtitle">{subTitle}</h4>

              <p className="recruitment__card-description">{description}</p>
            </div>
          )
        )}
      </div>

      {/* Button xem thêm */}
      <div className="recruitment__more-wrapper">
        <button
          className="recruitment__more-btn"
          type="button"
        >
          Xem thêm <FaArrowRight />
        </button>
      </div>
    </div>
  </section>
);

export default SessionRecruitment;
